import { useState, useContext, useEffect } from 'react';
import { 
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import { HighlightOffRounded, Cancel, CompareSharp } from '@mui/icons-material';
import { AuthContext } from 'components';
import { photo_url, tag_url } from 'config'

import "react-responsive-carousel/lib/styles/carousel.min.css";
import './Photos.css';
import round_x from 'components/Icons/round_x.png';
import {
  CancelIcon
} from 'components/Icons';
import { Carousel } from 'react-responsive-carousel';

const DeletePhoto = (props) => {
  const { onDelete, photo, tag } = props;
  const [ open, setOpen ] = useState(false);

  const handleClickOpen = () => {setOpen(true);};
  const handleClose = () => { setOpen(false); };
  const handleDelete = () => { 
    if (onDelete) {
      onDelete(() => {
        setOpen(false);
      });
    } else {
      setOpen(false);
    }
  };

  return (
    <>
      <CancelIcon 
        onClick={handleClickOpen}
        sx={{
          background: 'none',
          color: 'white',
          fontSize: '1em',
          borderRadius: '50%',
          cursor: 'pointer',
          position: 'absolute', 
          top: 0, 
          right: 0
        }}
      />
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>
          Are you sure you want to delete this {tag ? 'tag' : ''} photo?
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ textAlign: 'center' }}>
            <img alt="" style={{ width: '200px' }} key={photo.props.src} src={photo.props.src} />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleDelete} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export const PhotosField = (props) => {
  const { accountId } = useContext(AuthContext)
  const { photos, onChange, product, tags } = props
  const [ tag, setTag ] = useState(tags ? Object.keys(tags).filter(tag => !tags?.[tag]?.deleted) : [])

  useEffect(() => {
    if (tags) {
      setTag(Object.keys(tags).filter(tag => !tags?.[tag]?.deleted))
    }
  }, [tags])
  // const onChange = (e) => { console.log('onChange', e) }
  // const onClickItem = (e) => { console.log('onClickItem', e) }
  // const onClickThumb = (e) => { console.log('onClickThumb', e) }

  return (
    <Carousel 
      showArrows={true} 
      showStatus={false}
      showIndicators={false}
      // onChange={onChange} 
      // onClickItem={onClickItem} 
      // onClickThumb={onClickThumb}
      renderThumbs={(children) => {
        let thumbnails = children[0].map((item) => {
          return (
            <div key={item.props.src} style={{position: 'relative', height: '100px'}}>
              <DeletePhoto 
                onDelete={(callback) => {
                  let new_images = photos.filter(img => img !== item.props.id)
                  onChange({ photos: new_images })
                  callback()
                }}
                photo={item} 
              />
              <img alt="" src={item.props.src} />
            </div>
          )
        })

        if (children[1]) {
          thumbnails.push(children[1])
        }

        return thumbnails
      }}
    >
      {photos.map((image) => {
        return (
          <img 
            key={`carousel-img-${image}`}
            id={image}
            alt=""
            src={`${photo_url}/o/${accountId}%2F${image}.jpg?alt=media`}
          />
        )
      })}
      
      {tag.length > 0 ? (
        // <img 
        //   key={`carousel-img-${tag[0]}`}
        //   id={tag[0]}
        //   alt=""
        //   src={`${tag_url}/o/${accountId}%2F${product.tag[tag[0]].filename}.jpg?alt=media`}
        // />
        <div key={tag[0]} style={{position: 'relative', height: '100px'}}>
          <DeletePhoto 
            onDelete={(callback) => {
              const new_tags = Object.assign({}, tags)
              new_tags[tag[0]].deleted = true
              onChange({
                tag: new_tags,
                photos
              })
              callback()
            }}
            tag
            photo={{ props: { src: tag[0] } }} 
          />
          <img alt="" src={`${tag_url}/o/${accountId}%2F${product.tag[tag[0]].filename}.jpg?alt=media`} />
        </div>
      ) : null}
    </Carousel>
  )
}